import $ from 'jquery';
import BoxView from './views/BoxView';
import CollapsibleContentView from './views/CollapsibleContentView';
import DropSearchView from './views/DropSearchView';
import FileUploadView from './views/FileUploadView';
import FormValidation from './views/FormValidation';
import MenuView from './views/MenuView';
import ModalView from './views/ModalView';
import PasswordToggleView from './views/PasswordToggleView';
import ReportsActivityView from './views/ReportsActivityView';
import SideMenuView from './views/SideMenuView';
import TabView from './views/TabView';
import SelectView from './views/SelectView';
import TimeoutView from './views/TimeoutView';
import HasJS from 'nerdery-has-js';

const SELECTORS = {
    BOX_VIEW: '.js-box',
    COLLAPSIBLE_VIEW: '.js-collapsibleContent',
    DROP_SEARCH: '.js-dropSearch',
    FILE_UPLOAD: '.js-fileUpload',
    FORM_VALIDATION: '.js-validateForm',
    MENU_VIEW: '.js-headerNav',
    MODAL_VIEW: '.js-modal',
    PASSWORD_TOGGLE: '.js-passwordToggle',
    REPORTS_ACTIVITY: '.js-reportsActivity',
    SIDE_MENU: '.js-sideMenu',
    TAB_VIEW: '.js-tabView',
    SELECT_VIEW: '.js-selectView',
    TIMEOUT_VIEW: '.js-timeout',
};



/**
 * Application setup
 *
 * @class App
 */
export default class App {
    /**
     * Initialize App on startup
     * @class App
     * @constructor
     */
    constructor() {
        this.init();
    }

    /**
     * Initialize model, view, controller, components, services
     *
     * @method init
     */
    init() {
        HasJS.init();
        this.createChildren();

        return this;
    }


    /**
     * All constructor functions
     * are gathered under createChildren.
     *
     * @method createChildren
     * @public
     * @chainable
     * @returns {Object}
     */
    createChildren() {
        // Views
        this.getInstance(BoxView, $(SELECTORS.BOX_VIEW));
        this.getInstance(CollapsibleContentView, $(SELECTORS.COLLAPSIBLE_VIEW));
        this.getInstance(DropSearchView, $(SELECTORS.DROP_SEARCH));
        this.getInstance(FileUploadView, $(SELECTORS.FILE_UPLOAD));
        this.getInstance(FormValidation, $(SELECTORS.FORM_VALIDATION));
        this.getInstance(MenuView, $(SELECTORS.MENU_VIEW));
        this.getInstance(ModalView, $(SELECTORS.MODAL_VIEW));
        this.getInstance(PasswordToggleView, $(SELECTORS.PASSWORD_TOGGLE));
        this.getInstance(ReportsActivityView, $(SELECTORS.REPORTS_ACTIVITY));
        this.getInstance(SideMenuView, $(SELECTORS.SIDE_MENU));
        this.getInstance(TabView, $(SELECTORS.TAB_VIEW));
        this.getInstance(SelectView, $(SELECTORS.SELECT_VIEW));
        this.getInstance(TimeoutView, $(SELECTORS.TIMEOUT_VIEW));
    }

    /*
     : '.js-box',
     : '.js-collapsibleContent',
     : '.js-dropSearch',
     : '.js-fileUpload',
     : '.js-validateForm',
     : '.js-headerNav',
     : '.js-modal',
     : '.js-passwordToggle',
     : '.js-reportsActivity',
     : '.js-sideMenu',
     : '.js-tabView',
     : '.js-selectView',

    init() {
     this._boxView = new ('');
     this._collapsibleContentView = new ('');
     this._dropSearchView = new ();
     this._fileUploadView = new ();
     this._formValidation = new ();
     this._menuView = new ('');
     this._modalView = new ('');
     this._passwordToggleView = new ('');
     this._reportsActivityView = new ('');
     this._sideMenuView = new ();
     this._tabView = new ('');
     this._selectView = new '');

     return this;
     }*/

    getInstance(Name, container) {
        if (!this[Name]) {
            this[Name] = [];

            container.each((i, val) => {
                this[Name].push(
                    new Name($(val))
                );
            });

            return this[Name];
        }
        return this[Name];
    }
}
